interface MainProps {
  children: React.ReactNode;
}

const Main = ({ children }: MainProps) => {
  return <main className={"relative"}>{children}</main>;
};

export default Main;
